export default __webpack_public_path__ + "static/media/date.28c98a58.svg";